import { paths } from "helpers/paths";
import React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import Form from "./form";
import List from "./list";

/** Developer-only integration client administration routes. */
export default function IntegrationClients({ location }: RouteComponentProps) {
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={paths.integrationClients} component={List} />
                <Route exact path={paths.integrationClientsNew} component={Form} />
                <Route exact path={paths.integrationClient(":clientId")} component={Form} />
            </Switch>
        </div>
    );
}
